import FeeContent from "@/model/Content/FeeContent"
import getFormattedPrice from "@/logic/getFormattedPrice"

export interface IFee {
    getReference(): string
    getValue(): number
    getContent(): FeeContent | null
    setContent(content: FeeContent): void
}

class Fee implements IFee {
    private reference: string
    private value: number
    private content: FeeContent | null = null
    
    constructor(
        reference: string,
        value: number,
    ) {
        this.reference = reference
        this.value = value
    }

    public getReference(): string {
        return this.reference
    }
    public getValue(): number {
        return this.value
    }
    public getValueFormatted(locale: string): string {
        return getFormattedPrice(this.value, locale)
    }
    public getContent(): FeeContent | null {
        return this.content
    }
    public setContent(content: FeeContent): void {
        this.content = content
    }
}

export default Fee